import qs from 'qs';
import Logging from './logging';

const Account = {
    namespaced: true,
    state: {
        accountData: [],
    },

    getters: {
        accountData (state) {
            return state.accountData;
        },
    },

    mutations: {
        /**
         * Установить список Пользователей
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['accountData'] = items;
        },

        /**
         * Обновить Пользователя
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['accountData'][index] = item;
        },

        /**
         * Добавить Пользователя в список
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['accountData'].push(item);
        },

        /**
         * Удалить Пользователя
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['accountData'] = state['accountData'].filter(iItem => iItem !== item);
        },
    },

    actions: {
        /**
         * Получение данных о Пользователях
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getAccountData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                dispatch('ifAuth', true, { root: true });
                axios({
                    url: rootGetters.rootUrl +  'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'], 
                        'service' : rootGetters.service.account,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                        //console.debug(response.data),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные о пользователях получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN account.js | getAccountData: ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных о пользователях!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных о Пользователе
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveAccountData ({ commit, dispatch, getters, rootGetters }, data) {
            //console.debug(data)
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify({
                    id: data.data.id,
                    staffId: data.data.staffId,
                    username: data.data.username,
                    password: data.data.password,
                    fullname: data.data.fullname,
                    email: data.data.email,
                    phone: data.data.phone,
                    extId: data.data.extId,
                    isActive: data.data.isActive,
                    userStatus: data.data.userStatus,
                    isCustomer: data.data.isCustomer,
                    isManager: data.data.isManager,
                    isTest: data.data.isTest,
                    staffIdChange: data.data.staffIdChange
                });

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'], 
                        'service' : rootGetters.service.account,
                    }),
                }).then(async response => {
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        if (data.data.isActive) {

                        }
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные о пользователе успешно отредактированы!');
                    // Если сохранение нового
                    } else {
                        commit('addItem', {
                            item: response.data[0]
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый пользователь успешно создан!');
                    }

                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN account.js | saveAccountData: ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление Пользователя
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeAccountData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'], 
                        'service' : rootGetters.service.account,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Пользователь успешно удален!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении пользователя!');
                    console.log('ERROR IN account.js | removeAccountData: ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default Account;


// WEBPACK FOOTER //
// ./src/store/modules/account.js